import React from "react";
// import { render } from 'react-dom';
import FacebookLogin from "react-facebook-login";

// import LoginHOC from 'react-facebook-login-hoc'

const FacebookLoginComponent = ({ onLogin }) => {
  const facebookLoginHandler = (data) => {
    onLogin(data);
  };

  return (
    <FacebookLogin
      appId="1052448428170351"
      autoLoad={false}
      fields="name,email,picture"
      callback={facebookLoginHandler}
      icon="fa-facebook"
      textButton="Facebook"
    />
  );
};

export default FacebookLoginComponent;

// const configureLoginProps = {
//     scope: 'public_profile, email',
//     fields: 'name,email,picture',
//     xfbml: false,
//     cookie: false,
//     version: 2.6,
//     language: 'en_US',
//     appId: '699697547406211'
// }

// class FacebookLoginComponent extends Component {
//     constructor(props) {
//       super(props)

//       this.status = this.props.fb.status
//       this.login = this.props.fb.login
//       this.logout = this.props.fb.logout
//     }
//     getStatus(response) {
//       console.log(response, 'stats');
//       if (response.authResponse) {
//         this.responseApi.call(this, response.authResponse)
//       }
//     }
//     responseApi(res) {
//         console.log('token:', res, 'res');
//         console.log('token:', res.accessToken);
//     }
//     checkLoginState() {
//       this.status(this.getStatus.bind(this))
//     };
//     loginFacebook() {
//       this.login(this.getStatus.bind(this))
//     }
//     logoutFacebook() {
//       this.logout()
//     }
//     render() {
//       return (
//         <div>
//           {/* <button onClick={ this.checkLoginState.bind(this) }>Get Facebook Login Status</button> */}
//           <button className="kep-login-facebook metro" onClick={ this.loginFacebook.bind(this) }><i className="fa fa-facebook mr-3"></i> Facebook</button>
//           {/* <button onClick={ this.logoutFacebook.bind(this) }>Facebook Logout</button> */}
//         </div>

//       );
//     }
//   }

//   export default LoginHOC(configureLoginProps)(FacebookLoginComponent);
